<template>
  <b-modal
    v-model="trigger"
    :centered="true"
    :no-close-on-backdrop="dontCloseWhenClickedOutside"
    :no-close-on-esc="dontCloseWhenEscapePressed"
    :hide-header-close="dontShowCloseIcon"
    :hide-footer="true"
    :hide-header="true"
    @cancel="eventCancel($event)"
    :size="'lg'"
  >
    <div class="empanel-modal-close">
      <span v-if="!isEdit" class="Modal-head-text">Add Bank Details</span>
      <span v-if="isEdit" class="Modal-head-text">Edit Bank Details</span>
      <p class>
        <img
          @click="closeBankModal()"
          class="cursor-pointer modal-close-button mt-n1"
          style="float: right"
          src="@/assets/images/close1.svg"
        />
      </p>
    </div>
    <div class="row">
      <div class="col-6 mt-2">
        <b-form-group
          class="source-sans-pro text-left ml-4"
          label="Account Category"
        >
          <w-dropdown
            class="width-control-small"
            :options="accountCategories"
            @dropdownChange="getAccountCategories($event)"
            :selected="bankForm.accountCategoryCode"
          />
        </b-form-group>
      </div>
      <div class="col-6 mt-2">
        <b-form-group
          class="source-sans-pro text-left mr-4"
          label="Account Type"
        >
          <w-dropdown
            class="width-control-small"
            :options="accountTypeCategories"
            @dropdownChange="getAccountTypeCategories($event)"
            :selected="bankForm.accountTypeCode"
          />
        </b-form-group>
      </div>
    </div>
    <div class="row">
      <div class="col-6">
        <b-form-group
          class="source-sans-pro text-left ml-4"
          label="Payment Mode"
        >
          <w-dropdown
            class="width-control-small"
            :options="bankPaymentModes"
            @dropdownChange="getBankPaymentMode($event)"
            :selected="bankForm.paymentModeCode"
          />
        </b-form-group>
      </div>
      <div class="col-6">
        <w-text-input
          class="text-left mr-4"
          :labelName="$t('Payment in favour of')"
          @textInputChange="getPaymentInFavour($event)"
          validation="required|regex_company_name"
          :defaultValue="bankForm.accountHolderName"
          :maxCharacter="'100'"
        />
      </div>
    </div>
    <div class="row">
      <div class="col-6">
        <b-form-group class="source-sans-pro text-left ml-4" label="Bank Name">
          <w-dropdown
            class="width-control-small"
            :options="bankNameList"
            @dropdownChange="getBankName($event)"
            :selected="bankForm.bankCode"
          />
        </b-form-group>
      </div>
      <div class="col-6" v-if="!$root.isInternational">
        <b-form-group class="source-sans-pro field-headings">
          <w-text-input
            class="text-left mr-4"
            :labelName="$t('IFSC Code')"
            @textInputChange="getBankBranchIFSCCode($event)"
            validation="required|regex_ifsc"
            :defaultValue="bankForm.ifscCode"
            :inputAdditions="'mobile'"
            :maxDigits="'7'"
            :isdCode="ifscShortDesc"
            :disabled="!ifscShortDesc"
          />
          <p v-if="ifscErrorArray" class="ml-4 ifsc-invalid lato-regular">
            {{ $t("IFSC Code is Invalid") }}
          </p>
        </b-form-group>
      </div>

      <div class="col-6" v-if="$root.isInternational">
        <b-form-group class="source-sans-pro field-headings text-left mr-4">
          <w-text-input
            :labelName="$t('Swift Code')"
            @textInputChange="getBankSwiftBicCode($event, i)"
            validation="required|min:8|max:11|regex_swift"
            :defaultValue="bankForm.swiftBicCode"
            :inputAdditions="'mobile'"
            :maxDigits="'11'"
          />
        </b-form-group>
      </div>
    </div>
    <div class="row">
      <div class="col-6" v-if="$root.isInternational">
        <b-form-group
          class="source-sans-pro field-headings text-left ml-4"
          style="width: 280px"
        >
          <w-text-input
            :labelName="$t('IBAN Code')"
            @textInputChange="getBankIbanNumber($event, i)"
            validation="required|regex_alpha_numeric|max:34|min:5"
            :defaultValue="bankForm.ibanNumber"
            :inputAdditions="'mobile'"
            :maxDigits="'34'"
          />
        </b-form-group>
      </div>
      <div class="col-6 expanded-box">
        <b-form-group
          class="source-sans-pro field-headings ml-4"
          style="width: 305px"
        >
          <w-text-input
            class="mr-4"
            :labelName="$t('Account Number')"
            @textInputChange="getBankAccountNumber($event)"
            validation="required|min:3|max:25|regex_account_number"
            :defaultValue="bankForm.accountNumber"
            :inputAdditions="'mobile'"
          />
          <p
            class="mt-n2 ml-4 font-weight-bold text-danger lato-regular"
            v-if="duplicateAccountNumber == true"
          >
            Account Number is already exists
          </p>
        </b-form-group>
      </div>

      <div class="row">
        <div class="col-6 expanded-box2">
          <b-form-group
            class="source-sans-pro field-headings ml-4"
            :class="$root.isInternational"
            style="width: 285px"
          >
            <w-text-input
              :labelName="$t('Payment Confirmation Mail Id')"
              @textInputChange="getPaymentRefMailId($event)"
              :validation="'required|email'"
              :defaultValue="bankForm.paymentRefMailId"
              :maxCharacter="'100'"
              :type="'text'"
            />
          </b-form-group>
        </div>
        <div class="col-6 expanded-box" v-if="isSortCodeRequired">
          <b-form-group
            class="source-sans-pro field-headings ml-4"
            style="width: 285px"
          >
            <w-text-input
              :labelName="$t('Sort Code')"
              @textInputChange="getSortCode($event, i)"
              validation="required|min:4|max:9"
              :defaultValue="bankForm.sortCode"
              :inputAdditions="'mobile'"
              :maxDigits="'20'"
            />
          </b-form-group>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-8 mt-2">
        <FileUploader
          class="text-left ml-4"
          :id="'documentId'"
          :heading="'Attach Cancelled cheque or Relevant documents/proofs *'"
          @fileInputChange="getBankAttachment($event)"
        />
        <div class="col-10 ml-4 mt-1 p-0 pt-1" v-if="bankForm.documentId">
          <ul style="list-style-type: disc">
            <li>
              <a @click="showAttachFile(bankForm.documentId)" href="#">{{
                getFileName(bankForm.documentId)
              }}</a>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="row mt-3 mr-1">
      <div class="col">
        <b-button
          v-if="!isEdit"
          class="ml-2 button-class"
          :disabled="checkAllFilledFields()"
          @click="saveBankDetails('Y')"
          >Save</b-button
        >
        <b-button
          v-if="isEdit"
          class="ml-2 button-class"
          :disabled="checkAllFilledFields()"
          @click="saveBankDetails('N')"
          >Update</b-button
        >
      </div>
    </div>
    <w-loadingSpinner :loadSpinner="loading" />
  </b-modal>
</template>
<script>
import DropDown from "../widgets/DropDown";
var ifsc = require("ifsc");
import TextInput from "../widgets/TextInput";
import FileUploader from "../widgets/FileUploader";
import loadingSpinner from "../widgets/LoadingSpinner";
import { PartnerService } from "../services/partnerService";
import { OnBoardingServices } from "../services/onBoardingService";
const OnBoardingService = new OnBoardingServices();
const partnerService = new PartnerService();
export default {
  components: {
    "w-text-input": TextInput,
    "w-dropdown": DropDown,
    "w-loadingSpinner": loadingSpinner,
    FileUploader,
  },
  props: [
    "trigger",
    "dontCloseWhenClickedOutside",
    "dontShowCloseIcon",
    "dontCloseWhenEscapePressed",
    "categoryCode",
    "isEdit",
    "editBankDetail",
    "isAdmin",
    "partnerId",
    "isCustomer",
    "adminCompanyCode",
    "customerCompanyCode",
    "customerPartnerId",
  ],
  created() {
    this.getPartnerInfo();
    this.getAccountType();
  },
  data() {
    return {
      formChanged: false,
      bankForm: {
        companyCode: "",
        categoryCode: "",
        accountCategoryCode: "",
        accountTypeCode: "",
        accountHolderName: "",
        bankCode: "",
        ifscCode: "",
        swiftBicCode: "",
        ibanNumber: "",
        accountNumber: "",
        slNo: "",
        paymentModeCode: "",
        documentId: "",
        siteUrl: "",
        paymentRefMailId: "",
        sortCode: "",
      },
      ifscErrorArray: false,
      defaultCounryCode: '',
      bankPaymentModes: [],
      accountCategories: [],
      accountTypeCategories: [],
      bankNameList: [],
      ifscCodeList: [],
      companyCode: "",
      loading: false,
      isSortCodeRequired: false,
      duplicateAccountNumber: false,
      tempBankDetails: [],
    };
  },
  methods: {
    getEditBankDetail() {
      if (this.isEdit) {
        this.bankPaymentModes.forEach((element) => {
          if (element.text == this.editBankDetail.paymentMode) {
            this.bankForm.paymentModeCode = element.value;
          }
        });
        this.accountCategories.forEach((element) => {
          if (element.text == this.editBankDetail.accountCategory) {
            this.bankForm.accountCategoryCode = element.value;
          }
        });
        this.accountTypeCategories.forEach((element) => {
          if (element.text == this.editBankDetail.accountType) {
            this.bankForm.accountTypeCode = element.value;
          }
        });
        this.bankNameList.forEach((element) => {
          if (element.text == this.editBankDetail.bankName) {
            this.bankForm.bankCode = element.value;
          }
        });
        this.ifscShortDesc = this.editBankDetail.ifscCode != null ? this.editBankDetail.ifscCode.substr(0, 4) : 'SBIN';
        this.bankForm.accountHolderName = this.editBankDetail.paymentInfavourOf;
        this.bankForm.ifscCode = this.editBankDetail.ifscCode != null ? this.editBankDetail.ifscCode.substr(4, 7) : 'SBIN';
        this.bankForm.swiftBicCode = this.editBankDetail.swiftBicCode;
        this.bankForm.ibanNumber = this.editBankDetail.ibanNumber;
        this.bankForm.accountNumber = this.editBankDetail.accountNumber;
        this.bankForm.documentId = this.editBankDetail.documentId;
        this.bankForm.siteUrl = this.editBankDetail.siteUrl;
        this.bankForm.paymentRefMailId = this.editBankDetail.paymentRefMailId;
        this.bankForm.sortCode = this.editBankDetail.sortCode;
        this.$forceUpdate();
      }
    },
    getSortCodeRequired() {
      let sortCodeCompanyCode = null;
      if(this.companyCode){
        sortCodeCompanyCode = this.companyCode
      }
      if(this.customerCompanyCode){
        sortCodeCompanyCode = this.customerCompanyCode
      }
      if(this.adminCompanyCode){
        sortCodeCompanyCode = this.adminCompanyCode
      }
      let isSortCodeRequiredData = {
          chrDOPT: "C",
          intDTCode: 11381,
          intUID: 200,
          smallintCompanyCode: sortCodeCompanyCode,
          strValidationField: "IsSortCodeValidationRequired"
      };
      OnBoardingService.getDtValidation(isSortCodeRequiredData).then(resp => {
        if(resp.response && resp.response[0]) {
          if(resp.response[0].IsValidationApplicable == "Yes"){
            let isCountrySortCodeRequiredData = {
                chrDOPT: "C",
                intDTCode: 11381,
                intUID: 200,
                smallintCompanyCode: sortCodeCompanyCode,
                strValidationField: "SortCodeCountryValidation"
            };
            OnBoardingService.getDtValidation(isCountrySortCodeRequiredData).then(resp1 => {
              if(resp1.response) {
                const validationValues = resp1.response.map(item => item.ValidationValue);
                if(validationValues.includes(this.defaultCounryCode)) {
                  this.isSortCodeRequired = true
                }
              }
            });
          }
        }
      });
    },
    getBankAttachment(event) {
      this.loading = true;
      this.formChanged = true;
      console.log(event[0]);
      let data = new FormData();
      let file = event[0];
      console.log(file);
      // data.append("name", "my-file");
      data.append("file", file);
      OnBoardingService.uploadAttachments(data).then((resp) => {
        this.loading = false;
        if (resp) {
          this.bankForm.documentId = resp.UniqueID;
          this.bankForm.siteUrl = resp.SiteUrl;
        }
      });
    },
    showAttachFile(event) {
      this.loading = true;
      OnBoardingService.downLoadDocument(event)
        .then((res) => {
          this.loading = false;
        })
        .catch((e) => {
          window.alert("Something went wrong! try again later");
          this.loading = false;
        });
    },
    getFileName(fileName) {
      var fileNameFinal = "";
      fileNameFinal = fileName.split(/_(.+)/)[1];
      return fileNameFinal;
    },
    checkAllFilledFields() {
      if (!this.formChanged && this.isEdit) {
        return true;
      }
      if (
        this.bankForm.paymentModeCode &&
        this.bankForm.accountCategoryCode &&
        this.bankForm.accountTypeCode &&
        this.bankForm.accountHolderName &&
        this.bankForm.bankCode &&
        ((this.bankForm.ifscCode && !this.$root.isInternational) ||
          (this.bankForm.swiftBicCode &&
            this.bankForm.ibanNumber &&
            this.$root.isInternational)) &&
        this.bankForm.accountNumber &&
        this.bankForm.documentId &&
        this.errors.items.length == 0 &&
        this.ifscErrorArray == false &&
        this.duplicateAccountNumber == false &&
        this.bankForm.paymentRefMailId
      ) {
        return false;
      } else {
        console.log(this.ifscErrorArray);
        console.log(this.bankForm.ifscCode);
        return true;
      }
    },
    getPartnerInfo() {
      if (!this.isAdmin && !this.isCustomer) {
        partnerService.getPartnerInfo().then((resp) => {
          this.companyCode = resp.response.currentCompanyCode;
          this.$root.isInternational =
            resp.response.countryDetail.countryCode == 100 ? false : true;
          this.defaultCounryCode = resp.response.countryDetail.countryCode;
          this.getPartnerExistingBankDetails();
          this.getSortCodeRequired();
        });
      } else if (this.isAdmin) {
        partnerService.getPartnerInfo(true, this.partnerId).then((resp) => {
          this.companyCode = resp.response.currentCompanyCode;
          this.$root.isInternational =
            resp.response.countryDetail.countryCode == 100 ? false : true;
          this.defaultCounryCode = resp.response.countryDetail.countryCode;  
          // this.getPartnerExistingBankDetails();
        });
      } else if (this.isCustomer) {
        partnerService
          .getPartnerInfo(true, this.customerPartnerId)
          .then((resp) => {
            this.companyCode = this.customerCompanyCode;
            this.$root.isInternational =
              resp.response.countryDetail.countryCode == 100 ? false : true;
            this.defaultCounryCode = resp.response.countryDetail.countryCode;
            // this.getPartnerExistingBankDetails();
          });
      }
    },
    getAccountType() {
      OnBoardingService.getBankPaymentMode().then((resp) => {
        resp.response.forEach((modes) => {
          this.bankPaymentModes.push({
            text: modes.shortDesc,
            value: modes.paymentModeCode,
          });
        });
        OnBoardingService.getAccountType().then((resp) => {
          resp.response.forEach((bank) => {
            this.accountTypeCategories.push({
              text: bank.accTypeLongDesc,
              value: bank.accTypeCode,
            });
          });
          OnBoardingService.getBankAccountCategory().then((resp) => {
            resp.response.forEach((bankType) => {
              this.accountCategories.push({
                text: bankType.accCategoryLongDesc,
                value: bankType.accCategoryCode,
              });
            });
            OnBoardingService.getBankName().then((resp) => {
              resp.response.forEach((bank) => {
                this.bankNameList.push({
                  text: bank.longDesc,
                  value: bank.code,
                });
                this.ifscCodeList.push({
                  bankCode: bank.code,
                  ifscCode: bank.ifscShortCode,
                });
              });
              this.getEditBankDetail();
            });
          });
        });
      });
    },
    getBankNameDetails() {
      OnBoardingService.getBankName().then((resp) => {
        resp.response.forEach((bank) => {
          this.bankNameList.push({
            text: bank.longDesc,
            value: bank.code,
          });
          this.ifscCodeList.push({
            bankCode: bank.code,
            ifscCode: bank.ifscShortCode,
          });
        });
      });
    },
    getBankPaymentMode(event) {
      this.formChanged = true;
      this.bankForm.paymentModeCode = event;
    },
    getAccountCategories(event) {
      this.formChanged = true;
      this.bankForm.accountCategoryCode = event;
    },
    getAccountTypeCategories(event) {
      this.formChanged = true;
      this.bankForm.accountTypeCode = event;
    },
    getPaymentInFavour(event) {
      this.formChanged = true;
      this.bankForm.accountHolderName = event;
    },
    getBankName(event) {
      this.formChanged = true;
      this.bankForm.bankCode = event;
      this.bankForm.ifscCode = "";
      this.ifscCodeList.forEach((ifsc) => {
        if (ifsc.bankCode == this.bankForm.bankCode) {
          this.ifscShortDesc = ifsc.ifscCode;
          this.$forceUpdate();
        }
      });
    },
    getBankSwiftBicCode(event, i) {
      this.formChanged = true;
      this.bankForm.swiftBicCode = event.toUpperCase();
    },
    getSortCode(event, i) {
      this.formChanged = true;
      this.bankForm.sortCode = event.toUpperCase();
    },
    getBankIbanNumber(event, i) {
      this.formChanged = true;
      this.bankForm.ibanNumber = event.toUpperCase();
    },
    insertIFSCToTable(ifsccode, shortdesc) {
      var self = this;
      self.loading = true;
      ifsc
        .fetchDetails(ifsccode)
        .then(function (res) {
          self.loading = false;
          self.IFSCObj = res;
          var data = {};
          data.ifscCode = self.IFSCObj.IFSC;
          data.branchName = self.IFSCObj.BRANCH;
          data.branchAddresss = self.IFSCObj.ADDRESS;
          data.bankCity = self.IFSCObj.CITY;
          data.district = self.IFSCObj.DISTRICT;
          data.state = self.IFSCObj.STATE;
          data.micrCode = self.IFSCObj.MICR;
          data.swiftCode = self.IFSCObj.SWIFT;
          data.sortCode = self.IFSCObj.SORTCODE;
          OnBoardingService.insertIFSCCode(data)
            .then((resp) => {
              if (resp.status == "SUCCESS") {
                self.ifscErrorArray = false;
                self.showIfscCodeError = false;
                self.$forceUpdate();
              } else {
                self.ifscErrorArray = true;
                self.showIfscCodeError = true;
                self.$forceUpdate();
              }
            })
            .catch((err) => {
              self.loading = false;
              self.ifscErrorArray = true;
              self.showIfscCodeError = true;
              self.$forceUpdate();
            });
        })
        .catch((err) => {
          self.loading = false;
          self.ifscErrorArray = true;
          self.showIfscCodeError = true;
          self.$forceUpdate();
        });
    },
    getBankBranchIFSCCode(event) {
      this.formChanged = true;
      // this.bankForm.ifscCode = event;
      this.ifscErrorArray = false;
      this.bankForm.ifscCode = event.toUpperCase();
      if (this.bankForm.ifscCode.length === 7) {
        this.$forceUpdate();
        this.ifscArray =
          this.ifscShortDesc.trim() + this.bankForm.ifscCode.trim();
        if (event.length >= 7 && this.errors.items.length == 0) {
          OnBoardingService.checkIsfcCode(this.ifscArray).then((resp) => {
            if (resp.failureMessage == "IFSC Code Not Present") {
              this.showIfscCodeError = true;
              this.ifscErrorArray = true;
              this.$forceUpdate();
              this.insertIFSCToTable(this.ifscArray, this.ifscShortDesc);
            } else {
              this.ifscErrorArray = false;
              this.showIfscCodeError = false;
              this.$forceUpdate();
            }
          });
        }
      }
    },
    getBankAccountNumber(event) {
      this.formChanged = true;
      this.bankForm.accountNumber = event;
    },
    getPaymentRefMailId(event) {
      this.formChanged = true;
      this.bankForm.paymentRefMailId = event;
    },
    isValidateBankForm(bForm) {
      if (!this.$root.isInternational) {
        if (bForm.ifscCode.trim().length != 11) {
          window.alert("IFSC code should be 11 characters long");
          this.loading = false;
          return false;
        }
      }
      if (this.$root.isInternational) {
        if (
          bForm.swiftBicCode.trim().length < 8 ||
          bForm.swiftBicCode.trim().length > 11
        ) {
          window.alert("Check Swift code length");
          this.loading = false;
          return false;
        }
        if (
          bForm.ibanNumber.trim().length < 5 ||
          bForm.swiftBicCode.trim().length > 34
        ) {
          window.alert("Check Iban Number length");
          this.loading = false;
          return false;
        }
        if (
          !/[a-zA-Z]{6}[a-zA-Z0-9]{2}([a-zA-Z0-9]{3})?$/.test(
            bForm.swiftBicCode
          )
        ) {
          window.alert("Swift Code Invalid");
          this.loading = false;
          return false;
        }
      }
      return true;
    },
    saveBankAdmin() {
      this.loading = true;
      var self = this;
      this.bankForm.companyCode = this.adminCompanyCode;
      this.bankForm.categoryCode = this.categoryCode;
      this.bankForm.documentNumber = this.editBankDetail.documentNo;
      this.bankForm.slNo = "";
      this.bankForm.partnerId = this.partnerId;
      var tempForm = Object.assign({}, this.bankForm);
      tempForm.ifscCode =
        this.ifscShortDesc.trim() + this.bankForm.ifscCode.trim();

      if (!this.isValidateBankForm(tempForm)) {
        return false;
      }
      partnerService
        .saveBankDetailAdmin(tempForm)
        .then((res) => {
          if (res.failureMessage != "") {
            window.alert(res.failureMessage);
            this.loading = false;
          }
          if (res.status == "SUCCESS") {
            this.loading = false;
            window.alert(res.response);
            self.$router.go(0);
          }
        })
        .catch((e) => {
          this.loading = false;
          window.alert("Something went wrong! try again later");
        });
    },
    saveBankCustomer() {
      var self = this;
      this.bankForm.companyCode = this.customerCompanyCode;
      this.bankForm.categoryCode = 5;
      this.bankForm.documentNumber = this.editBankDetail.documentNo;
      this.bankForm.slNo = "";
      this.bankForm.partnerId = this.customerPartnerId;
      var tempForm = Object.assign({}, this.bankForm);
      tempForm.ifscCode =
        this.ifscShortDesc.trim() + this.bankForm.ifscCode.trim();

      if (!this.isValidateBankForm(tempForm)) {
        return false;
      }
      var data = {
        accounts: [
          {
            accountCategoryCode: this.bankForm.accountCategoryCode,
            accountHolderName: this.bankForm.accountHolderName,
            accountNumber: this.bankForm.accountNumber,
            accountTypeCode: this.bankForm.accountTypeCode,
            bankName: this.bankForm.bankCode,
            ibanNumber: this.bankForm.ibanNumber,
            ifscCode: tempForm.ifscCode,
            paymentModeCode: this.bankForm.paymentModeCode,
            paymentRefMailId: this.bankForm.paymentRefMailId,
            slNo: 1,
            swiftBicCode: this.bankForm.swiftBicCode,
            documentId: this.bankForm.documentId,
            sortCode: this.bankForm.sortCode,
          },
        ],
        categoryCode: 5,
        companyCode: this.customerCompanyCode,
        isMigratedUser: "N",
        partnerId: this.customerPartnerId,
      };

      partnerService
        .saveBankDetailCustomer(data)
        .then((res) => {
          if (res.failureMessage != "") {
            window.alert(res.failureMessage);
            this.loading = false;
          }
          if (res.status == "SUCCESS") {
            this.loading = false;
            window.alert(res.response);
            self.closeBankModal();
            EventBus.$emit("customerBankAdded");
          }
        })
        .catch((e) => {
          this.loading = false;
          window.alert("Something went wrong! try again later");
        });
    },
    saveBankDetails(isCreate) {
      if (this.isAdmin) {
        this.saveBankAdmin("Y");
      } else if (this.isCustomer) {
        this.saveBankCustomer();
      } else {
        this.loading = true;
        this.bankForm.companyCode = this.companyCode;
        this.bankForm.categoryCode = this.categoryCode;
        this.bankForm.documentNumber = this.editBankDetail.documentNo;
        if (this.isEdit) {
          this.bankForm.slNo = this.editBankDetail.slNo;
        }
        var tempForm = Object.assign({}, this.bankForm);
        tempForm.ifscCode =
          this.ifscShortDesc.trim() + this.bankForm.ifscCode.trim();
        partnerService
          .saveBankDetail(tempForm, isCreate)
          .then((res) => {
            if (res.response) {
              this.loading = false;
              this.$emit("afterSave");
            }
            if (res.failureMessage) {
              window.alert(res.failureMessage);
              this.loading = false;
            }
          })
          .catch((e) => {
            this.loading = false;
            window.alert("Something went wrong! try again later");
          });
      }
      this.getPartnerExistingBankDetails();
      this.getSortCodeRequired();
    },
    closeBankModal() {
      this.$emit("eventClose");
    },
    getPartnerExistingBankDetails() {
      partnerService
        .quickLinkPage(this.categoryCode, this.companyCode)
        .then((res) => {
          if (res) {
            for (let i = 0; i < res.response.bankDetails.length; i++) {
              this.tempBankDetails.push(res.response.bankDetails[i]);
            }
          }
        })
        .catch((err) => {
          window.alert("Something went wrong! try again later");
          console.log(err);
        });
    },
  },
};
</script>
<style scoped>
.button-class {
  width: 100px;
  height: 30px;
  font-family: "Source Sans Pro", sans-serif;
  font-size: 14px;
  color: white !important;
  border-radius: 2px;
  background-color: #1579ab;
  margin-bottom: 30px;
  display: block;
  margin-left: auto !important;
  margin-right: auto !important;
}
.button-class:disabled {
  color: white !important;
}
.ifsc-invalid {
  position: absolute;
  margin: 0 auto;
  font-size: 12px;
  font-weight: 600;
  font-style: normal;
  color: #d92121;
  margin-top: -12px;
}
.expanded-box {
  margin-left: -25px;
}
.expanded-box2 {
  margin-left: 12px;
}
</style>